/**
 * EventBus 事件总线
 * 用于组件间通信，特别是届次切换事件的传递
 */
import Vue from 'vue'

// 创建一个新的 Vue 实例作为事件总线
export default new Vue()
